import { Route, Routes, useNavigate } from "react-router-dom";
import Home from "../pages/DefaultPage";
import { useEffect } from "react";
import { IFirstLineRoutes } from "../App.interface";
import ChatForm from "../pages/first-line/ChatForm";
import CallForm from "../pages/first-line/CallForm";

const FirstLineRoutes = ({
  route,
  leadId,
  phone,
}: {
  route: IFirstLineRoutes;
  leadId: number | null;
  phone: string | null;
}) => {
  const navigate = useNavigate();

  useEffect(() => {
    switch (route) {
      case IFirstLineRoutes.chatForm:
        navigate("/chat-from");
        break;
      case IFirstLineRoutes.callForm:
        navigate("/call-form");
        break;
      default:
        navigate("/");
        break;
    }
  }, [route, navigate]);

  return (
    <Routes>
      <Route path="/" element={<Home></Home>}></Route>
      <Route
        path="/chat-from"
        element={<ChatForm key={phone} phone={phone}></ChatForm>}
      ></Route>
      <Route
        path="/call-form"
        element={<CallForm key={leadId} leadId={leadId} phone={phone}></CallForm>}
      ></Route>
    </Routes>
  );
};

export default FirstLineRoutes;
